<template>
  <div class="mb-4">
    <vx-card v-if="!formMode" :key="`${data.id}`" :subtitle="`${type} (${data.mark} درجة)`" collapseAction contentCollapse no-shadow card-border>
      <text-editor-viewer slot="title" class="text-xl" :data="data.title" />
      <template slot="moreActions" v-if="isTeacher && !viewOnly">
        <feather-icon v-if="!editOnly" @click="duplicate" icon="CopyIcon" svg-classes="w-5 h-5 ml-4 hover:text-primary" />
        <feather-icon @click="formMode = true" icon="EditIcon" svg-classes="w-5 h-5 ml-4 hover:text-primary" />
        <feather-icon v-if="!editOnly" @click="$emit('remove', data)" icon="TrashIcon" svg-classes="w-5 h-5 ml-4 hover:text-danger" />
      </template>
      <div>
        <text-editor-viewer v-if="data.type === 'plain' && data.answer" :data="data.answer" />
        <ul v-else>
          <li v-for="(choice, choiceIndex) in data.choices" :key="`${data.id}-${choiceIndex}`"
              class="flex h-16 p-4 mt-4 items-center justify-between border border-solid border-grey rounded-lg ">
            <span>{{choice.choice_title}}</span>
            <vs-chip v-if="parseInt(data.answer) === choiceIndex" class="m-0" color="primary">الإجابة الصحيحة</vs-chip>
          </li>
        </ul>
      </div>
    </vx-card>
    <question-form v-else-if="isTeacher && !viewOnly"
                   :disableBtns="loading"
                   :key="`${data.id}-edit`"
                   :data="data"
                   :editOnly="editOnly"
                   @submit="save"
                   @close="formMode = false"/>
  </div>
</template>

<script>
    import QuestionForm from '@/views/questionBanks/QuestionForm'
    import questionsAPI from '@/api/questionsAPI'
    import TextEditorViewer from '@/views/components/TextEditorViewer'

    export default {
        name: 'QuestionItem',
        components: { TextEditorViewer, QuestionForm },
        props: {
            data: {
                required: true,
                type: Object
            },
            viewOnly: {
                type: Boolean,
                default: false
            },
            editOnly: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            formMode(val){
                if(!val && !this.data.id) this.$emit('remove', this.data)
            }
        },
        computed: {
            type(){
                switch (this.data.type) {
                    case 'plain' : return 'سؤال مقالي'
                    case 'true/false' : return 'الصح والخطأ'
                    case 'choices' : return 'الإختيار من المتعدد'
                    default : return ''
                }
            },
        },
        data () {
            return {
                formMode: false,
                loading: false,
            }
        },
        methods: {
            save(question){
                question.id ? this.update(question) : this.add(question)
            },
            duplicate(){
                const question = Object.assign({duplicated: true}, this.data)
                questionsAPI.create(question)
                    .then(response => {
                        question.id = response.data.id
                        this.$emit('save', question)
                        this.formMode = false
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
            },
            add(question){
                this.loading = true
                questionsAPI.create(question)
                    .then(response => {
                        question.id = response.data.id
                        this.$emit('save', question)
                        this.formMode = false
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.loading = false)
            },
            update(question){
                this.loading = true
                questionsAPI.update(question.id, question)
                    .then(response => {
                        this.$emit('save', question)
                        this.formMode = false
                        this.$forceUpdate()
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.loading = false)
            },
        },
        created() {
            if(!this.data.id) this.formMode = true

            if(this.data.type === 'true/false') {
                this.data.choices = [{choice_title: 'صحيح'},{choice_title: 'خطأ'}]
            }
        }
    }
</script>
